import { render } from "./CallbackSpotify.vue?vue&type=template&id=6bb14f6a"
import script from "./CallbackSpotify.vue?vue&type=script&lang=js"
export * from "./CallbackSpotify.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__